import { SVGProps } from 'react'

const SvgDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' {...props}>
    <path d='M128 192l128 128 128-128z' />
  </svg>
)

export default SvgDown
